import { IGroupBasicInfo, IGroupInfo } from '../models/IGroupInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DeleteGroupAction } from './DeleteGroupAction';

export let GroupUsersEvent = {
  usersRemoved: 'usersRemoved',
  usersAdded: 'usersAdded'
};

export class GroupActions {

  public static $inject = [
    'DeleteGroupAction',
  ];


  constructor(
    private DeleteGroupAction: DeleteGroupAction,
  ) {
  }

  // public api

  public deleteGroup(group: IGroupBasicInfo, dialogScope: ng.IScope): ng.IPromise<any> {
    const groups = new Set<IGroupBasicInfo>((group: IGroupInfo) => group.id);
    groups.add(group);
    return this.DeleteGroupAction.showDeleteGroupDialog(groups, dialogScope);
  }
}

Module.instance().service('GroupActions', GroupActions);
